import PropTypes from "prop-types";
import classNames from "classnames";
import AtomPrimaryButton from "components/source/atoms/atom-primary-button";

const AtomStickyPrimaryButton = ({
  buttonText,
  bottomButtonText,
  buttonOnClick = () => {},
  bottomButtonOnClick = () => {},
  dataTestId,
  isVisible,
}) => {
  const stickyCtaClass = classNames("sticky-cta-container", {
    visible: isVisible,
  });

  return (
    <div className={stickyCtaClass}>
      <AtomPrimaryButton
        className={"sticky-cta__button"}
        onClick={buttonOnClick}
        buttonText={buttonText}
        dataTestId={dataTestId}
      />
      {bottomButtonText && (
        <button className="sticky-cta__lower-button" onClick={bottomButtonOnClick}>
          {bottomButtonText}
        </button>
      )}
    </div>
  );
};

AtomStickyPrimaryButton.propTypes = {
  buttonText: PropTypes.string,
  bottomButtonText: PropTypes.string,
  buttonOnClick: PropTypes.func,
  bottomButtonOnClick: PropTypes.func,
  dataTestId: PropTypes.string,
  isVisible: PropTypes.bool,
};

export default AtomStickyPrimaryButton;
